import { ProductType } from '@/lib/graphql/generated/graphql';
import { filteredFlatRowsState } from '@/states/filtered-flat-rows.state';
import { atom } from 'jotai';

// Derived atom that calculates hasCouponsInCurrentView from filteredFlatRows
export const hasCouponsInCurrentViewState = atom((get) => {
  const filteredFlatRows = get(filteredFlatRowsState);
  return filteredFlatRows.some(
    (row) => row.original.activeVersion.productType === ProductType.Coupon
  );
});
